import { render, staticRenderFns } from "./MaterialChartCard.vue?vue&type=template&id=a257951a&scoped=true"
import script from "./MaterialChartCard.vue?vue&type=script&lang=js"
export * from "./MaterialChartCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialChartCard.vue?vue&type=style&index=0&id=a257951a&prod&lang=sass"
import style1 from "./MaterialChartCard.vue?vue&type=style&index=1&id=a257951a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a257951a",
  null
  
)

export default component.exports